import { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { IMAGES } from '../../mock';
import CareersModal from '../CareersModal';

export default function Careers() {
  const [open, setOpen] = useState(false);
  return (
    <section id="about" className="relative py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative rounded-[32px] overflow-hidden bg-[#0B3B2E] text-[#F5F1E8]">
          <div className="absolute inset-0">
            <img
              src={IMAGES.careers}
              alt="Team at Vector FX"
              className="w-full h-full object-cover opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0B3B2E] via-[#0B3B2E]/85 to-[#0B3B2E]/40" />
          </div>

          <div className="relative grid lg:grid-cols-12 gap-10 p-10 lg:p-20">
            <div className="lg:col-span-7">
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#C8944B]">
                Careers
              </p>
              <h2 className="mt-4 font-serif text-[42px] lg:text-[62px] leading-[1.02]">
                Build the future of<br />
                <span className="italic">cross-border money.</span>
              </h2>
              <p className="mt-6 max-w-[520px] text-[16px] leading-relaxed text-[#F5F1E8]/75">
                Vector FX is 340 people across 14 countries: engineers, compliance experts,
                treasurers, designers, all obsessed with removing friction from international
                payments. We hire humans, not headcount.
              </p>

              <div className="mt-9 flex flex-wrap gap-3">
                <button
                  onClick={() => setOpen(true)}
                  className="inline-flex items-center gap-1.5 px-6 h-12 rounded-full bg-[#C8944B] text-[#0B3B2E] font-medium text-[15px] hover:bg-[#D9A85C] transition-colors"
                >
                  Open roles <ArrowUpRight className="w-4 h-4" />
                </button>
                <a
                  href="#"
                  className="inline-flex items-center gap-1.5 px-6 h-12 rounded-full border border-[#F5F1E8]/25 text-[#F5F1E8] font-medium text-[15px] hover:bg-[#F5F1E8]/8 transition-colors"
                >
                  About Vector FX
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 lg:pl-10 lg:border-l border-[#F5F1E8]/15">
              <div className="space-y-6">
                <Stat n="340" label="People" />
                <Stat n="14" label="Countries" />
                <Stat n="22" label="Open roles this quarter" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CareersModal open={open} onOpenChange={setOpen} />
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div className="flex items-baseline justify-between gap-4 pb-4 border-b border-[#F5F1E8]/15">
      <span className="font-serif text-[46px] lg:text-[56px] leading-none">{n}</span>
      <span className="text-[13px] text-[#F5F1E8]/70 tracking-wide">{label}</span>
    </div>
  );
}
